<template>
  <span class="d-inline-flex">
    <v-switch
      density="compact"
      v-model="value"
      color="primary"
      :label="label"
      hide-details="auto"
      class="d-inline-flex"></v-switch>
    <span v-if="field.required" class="text-red required-bool-label"><strong>*</strong></span>
  </span>
</template>

<script>
import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';

export default {
  name: 'custom-field-bool-old',
  mixins: [customFieldTypeMixinOld],
  computed: {
    label() {
      return this.value ? 'Yes' : 'No';
    }
  }
};
</script>
